import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Crown, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * iter_516 — After a gifted membership ends (or is about to), ask the
 * recipient on login whether they'd like to keep it with a paid plan.
 * Shows once per session; "Not now" dismisses it on the server.
 */
export default function RenewalGate() {
  const { token, isAuthenticated } = useAuth();
  const [prompt, setPrompt] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || !token) return;
    if (sessionStorage.getItem('renewal_gate_seen')) return;
    axios.get(`${API}/pro-plans/status`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => { if (r.data?.renewal_prompt) setPrompt(r.data.renewal_prompt); })
      .catch(() => {});
  }, [isAuthenticated, token]);

  const close = () => { sessionStorage.setItem('renewal_gate_seen', '1'); setPrompt(null); };

  const dismiss = async () => {
    try { await axios.post(`${API}/pro-plans/renewal/dismiss`, {}, { headers: { Authorization: `Bearer ${token}` } }); } catch (e) { /* noop */ }
    close();
  };

  const renew = () => { close(); navigate('/pro-plans'); };

  if (!prompt) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-black/70 flex items-center justify-center p-4" data-testid="renewal-gate">
      <div className="bg-[#0d0d0d] border-2 border-[#FFDA33] rounded-xl max-w-sm w-full p-6 text-center">
        <button onClick={dismiss} className="absolute top-3 right-3 text-[#888] hover:text-white" aria-label="Close"><X size={18} /></button>
        <Crown size={32} className="text-[#FFDA33] mx-auto mb-3" />
        <h3 className="font-['Chakra_Petch'] uppercase text-white text-lg mb-2">
          {prompt.ended ? `Your ${prompt.label} gift has ended` : `Your ${prompt.label} gift is ending soon`}
        </h3>
        <p className="text-[#aaa] font-mono text-xs mb-5">
          Keep your perks going — renew {prompt.label} for ${prompt.monthly}/mo or ${prompt.annual}/yr. No pressure; you can skip.
        </p>
        <div className="flex gap-2">
          <button onClick={dismiss} className="flex-1 py-2.5 rounded-lg border border-[#333] text-[#aaa] font-mono text-sm" data-testid="renewal-skip">Not now</button>
          <button onClick={renew} className="flex-1 py-2.5 rounded-lg bg-[#FFDA33] text-black font-['Chakra_Petch'] uppercase text-sm" data-testid="renewal-renew">Renew</button>
        </div>
      </div>
    </div>
  );
}
